import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";

// Styles
import { GlobalStyles } from "./styles/GlobalStyles";
import { theme } from "./styles/theme";

// Layout Components
import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/Common/ScrollToTop";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import LorisHolland from "./pages/LorisHolland";
import Ministries from "./pages/Ministries";
import Events from "./pages/Events";
import Store from "./pages/Store";
import Books from "./pages/Books";
import Contact from "./pages/Contact";

// Ministry Pages
import TheMillennium from "./pages/Ministries/TheMillennium";
import CaughtUpClub from "./pages/Ministries/CaughtUpClub";
import MondayMusicians from "./pages/Ministries/MondayMusicians";
import CareMusicTours from "./pages/Ministries/CareMusicTours";
import MinistryBeforeIndustry from "./pages/Ministries/MinistryBeforeIndustry";
import WorshipAcademy from "./pages/Ministries/WorshipAcademy";
import QuietKindness from "./pages/Ministries/QuietKindness";

import Project24 from "./pages/Ministries/Project24";

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Router>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/about/loris-holland" element={<LorisHolland />} />
                <Route path="/ministries" element={<Ministries />} />
                <Route
                  path="/ministries/the-millennium"
                  element={<TheMillennium />}
                />
                <Route
                  path="/ministries/caught-up-club"
                  element={<CaughtUpClub />}
                />
                <Route
                  path="/ministries/monday-musicians"
                  element={<MondayMusicians />}
                />
                <Route
                  path="/ministries/care-music-tours"
                  element={<CareMusicTours />}
                />
                <Route
                  path="/ministries/ministry-before-industry"
                  element={<MinistryBeforeIndustry />}
                />
                <Route
                  path="/ministries/worship-academy"
                  element={<WorshipAcademy />}
                />
                <Route
                  path="/ministries/quiet-kindness"
                  element={<QuietKindness />}
                />
                <Route path="/ministries/ministry-before-industry/project-24" element={<Project24 />} />
                <Route path="/events" element={<Events />} />
                <Route path="/store" element={<Store />} />
                <Route path="/books" element={<Books />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
